import React, { useState, useEffect } from "react"
import CreatePayrollPage from "../../../../entities/DashboardPage/HRModule/Payroll"
import AuthService from "../../../../api/AuthService";
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../context/AlertContext";
import { useLocation, useNavigate } from "react-router-dom";

function CreatePayroll() {
  useEffect(() => {
    getDepartment();
  }, [])


  const [loading, setLoading] = useState(false);
  const [employeeData, setEmployeeData] = useState([]);
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { item, from } = state || {};
  const [data, setData] = useState(item);
  const [departmentData, setDepartmentData] = useState([]);
  const [depData, setDepData] = useState([]);
  const [empData, setempData] = useState([]);

  useEffect(() => {
    getAllDepartmentList();
  }, [])

  const getAllDepartmentList = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAllDepartmentList();
      if (result?.success) {
        setempData(result?.data);

        LoaderHelper.loaderStatus(false);

      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const SearchEmployee = async (text) => {
    setLoading(true);
    if (!text) {
      setLoading(false);
      return;
    }
    try {
      const result = await AuthService.getEmployeeList(text);
      if (result?.success) {
        setEmployeeData(result?.data?.employees);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const getPayroll = async (id) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getPayroll(id);
      if (result?.success) {
        setData(result?.data?.payrolls);
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };

  const handlePayroll = async (fromDate, toDate, frequency, payroll, allId, paymentMethod, department, removeEmployeesByName) => {
    setLoading(true);

    try {
      if (new Date(toDate) < new Date(fromDate)) {
        showAlert("End date cannot be before start date.", "error");
        setLoading(false)
        return;
      }
      const result = await AuthService.createPayroll(fromDate, toDate, frequency, payroll, allId, paymentMethod, department);
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message, "success");
        navigate("/dashboard/payrollModule")
      } else if (result?.success === false) {
        setLoading(false);
        showAlert(result?.message, "error");
        
        if (result?.message && removeEmployeesByName) {
          const errorMessage = result.message;
          const colonIndex = errorMessage.indexOf(':');
          
          if (colonIndex !== -1) {
            const emailsString = errorMessage.substring(colonIndex + 1).trim();
            const emails = emailsString.split(',').map(item => item.trim()).filter(item => item.includes('@') && item.length > 0);
            
            console.log('📧 Emails from API error:', emails);
            
            if (emails.length > 0) {
              removeEmployeesByName(emails);
              showAlert("Duplicate employees removed from list. Click 'Create New' again.", "success");
            }
          }
        }
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const handleUpdate = async (payrollId, fromDate, toDate, frequency, employeeId, paymentMethod, department) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.handleAddPayroll(payrollId, fromDate, toDate, frequency, employeeId, paymentMethod, department);
      if (result?.success) {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
        navigate("/dashboard/payrollModule")
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleUpdatePayrollEmployee = async (payrollId, action, employeeId) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.handlePayrollEmployee(payrollId, action, employeeId);
      if (result?.success) {
        getPayroll(payrollId)
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
        getPayroll(payrollId)
        navigate("/dashboard/payrollModule")
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getDepartment = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getDepartment();
      if (result?.success) {
        setDepartmentData(result?.data?.position);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const DepartmentPayroll = async (department) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handlePayrollDepartmemt(department);
      if (result?.success) {
        setDepData(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  return (
    <CreatePayrollPage SearchEmployee={SearchEmployee} data={data} from={from} handleUpdatePayroll={handleUpdate}
      employeeData={employeeData} loading={loading} submitPayroll={handlePayroll} handleDeleteEmployee={handleUpdatePayrollEmployee}
      departmentData={departmentData} DepartmentPayroll={DepartmentPayroll} depData={depData}
      empData={empData} />
  )
}

export default CreatePayroll